<template>
    <Frame>
        <PageHeader :title="$t('orderArrival.orderArrivalSearch')" :hasBack="false" />
        <div class="list-contain">
            <div class="head-contain">

                <div class="filter-contain" style="width: 34%;">
                    <span>{{ $t('orderArrival.reciveDate') }}：</span>
                    <el-date-picker v-model="rangeDate" type="daterange" size="small" range-separator="~"
                        :start-placeholder="$t('comm.startdate')" :end-placeholder="$t('comm.enddate')"
                        :picker-options="PickerOptions" :unlink-panels="true" @change="changeTime()">
                    </el-date-picker>
                </div>

                <div class="filter-contain">
                    <span>{{ $t('orderArrival.orderBillNo') }}</span>
                    <el-input v-model="BillNo" :placeholder="$t('orderArrival.inputpls')" size="small" clearable></el-input>
                </div>

                <div class="filter-contain">
                    <span>{{ $t('orderArrival.customerNoLab') }}</span>
                    <el-input v-model="customerPayNo" :placeholder="$t('orderArrival.inputpls')" size="small" clearable></el-input>
                </div>

                <div style="width:16%;"> 
                    <span style="width: 100%;display: flex; justify-content: flex-end;">
                        <el-button type="reset" @click="reset()">{{ $t('button.reset') }}</el-button>
                        <el-button type="primary" @click="GetListData(0)">{{ $t('button.query') }}</el-button>
                    </span>
                </div>
            </div>
        </div>
    <el-table ref="multipleTable" :data="tableData" :height="tableHeight" style="margin:0;width:100%" v-loading="tableLoading">
      <el-table-column :min-width="WidthControl('FromOrderBillNo', tableData)" prop="FromOrderBillNo" :label="$t('orderArrival.fromOrderBillNo')">
        <template scope="scope">
          <el-link :underline="false" @click="viewOrderDetail(scope.row)">{{ scope.row.FromOrderBillNo }}</el-link>
        </template>
      </el-table-column>
      <el-table-column :min-width="WidthControl('X_Or',tableData)" prop="X_Or" label="OR"></el-table-column>
      <el-table-column :min-width="WidthControl('X_CustNumberOrg',tableData)" prop="X_CustNumberOrg" :label="$t('orderArrival.custNumber')"></el-table-column>
      <el-table-column :min-width="WidthControl('BPMaterialId',tableData)" prop="BPMaterialId" label="ItemCode"></el-table-column>
      <el-table-column :min-width="WidthControl('BPMaterialName',tableData)" prop="BPMaterialName" label="ItemName"></el-table-column>
      <el-table-column :min-width="WidthControl('ReceivingSQty',tableData)"  prop="ReceivingSQty" :label="$t('orderArrival.receivingSQty')" align="right"></el-table-column>
      <el-table-column :min-width="WidthControl('ReciveDate',tableData)" prop="ReciveDate" :label="$t('orderArrival.reciveDate')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_Addr',tableData)" prop="X_Addr" :label="$t('orderArrival.address')"></el-table-column>
      <el-table-column :label="$t('orderArrival.operation')">
        <template slot-scope="scope">
          <el-button class="topbutton" size="mini" type="text" @click="viewOrderDetail(scope.row)">{{ $t('button.check') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
        <div class="footer-contain">
            <PageSizeChanger :pagesize="pageSize" :afterChange="pageSizeChange"></PageSizeChanger>
            <el-pagination ref="pagination" class="pagination" @current-change="handleCurrentChange"
                layout="total,prev,pager,next,jumper" :pager-count="pagecount" :current-page="currentPage"
                :total="totalCount" :page-size="pageSize">
            </el-pagination>
        </div>

    </Frame>
</template>
<script>
import { listMixin } from '@/agency/mixin/mixin.js'
import { datePickerOptions,handleShortDate } from '@/utils/handleDate'
export default {
  name: "OrderArrival",
  mixins: [listMixin],
  data() {
    return {
      rangeDate:[],//过滤条件
      BillNo:'',
      customerPayNo:'',
      PickerOptions: datePickerOptions(this),
      tableData: [], //当前页数据
      pageIndex: 0,
      totalCount: 0,
      tableLoading: false,
      resizeFlag: null,
      tableHeight: window.innerHeight - 260,
      pagecount: 5,
    };
  },
  props: {
    GetListData: {
      type: Function,
      default: function(pageIndex, ...arg) {
        this.getListData(pageIndex, ...arg);
      }
    }
  },
  mounted() {
    this.frameOnResize(260);
  },
  created() {
    this.rangeDate = this.recentWeeks();
    this.startDate = handleShortDate(this.rangeDate[0], "From");
    this.endDate = handleShortDate(this.rangeDate[1], "To");
    this.GetListData(0);
  },
  methods: {
    recentWeeks() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        return [start, end];
    },
    changeTime() {
        this.getTime();
        this.GetListData(0);
    },
    viewOrderDetail(row) {
      this.$router.push({
        path: '/Home/OrderArrivalDetail',
        query: {
          BillNo: row.FromOrderBillNo
          }
      })
    },
    getListData(index) {
      this.pageIndex = index;
      this.tableLoading = true;
      this.axiosInvoke(this.YMBillHandlerUrl,{
          action: "getorderarrivallist",
          startDate: this.startDate,
          endDate: this.endDate,
          BillNo:this.BillNo,
          customerPayNo:this.customerPayNo,
          pageIndex: this.pageIndex,
          pageSize: this.$store.state.pagesize
        },(res) => {
          const data = res.data;
          this.tableLoading = false;
          this.tableData = data.DataTable ? data.DataTable : [];
          this.totalCount = data.totalCount;
        },false,true);
    }, 
    handleCurrentChange(page) {
      this.pageIndex = page - 1;
      this.GetListData(this.pageIndex);
    },
    pageSizeChange() {
      this.GetListData(0);
    },
    reset() {
      this.rangeDate = this.recentWeeks();
      this.startDate = handleShortDate(this.rangeDate[0], "From");
      this.endDate = handleShortDate(this.rangeDate[1], "To");
      this.BillNo = '';
      this.customerPayNo = '';
      this.tableData = [];
      this.pageIndex = 0;
      this.totalCount = 0;
    },
  }
};
</script>
<style scoped>
.list-contain {
  display: flex;
  padding: 10px 0px;
}
.head-contain {
  padding: 0 20px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.filter-contain {
  width: 23%;
  padding-right: 1%;
  display: flex;
  flex-wrap: nowrap;
  padding-bottom: 10px;
}
.filter-contain > span {
  color: black;
  font-size: 14px;
  margin: auto;
  white-space: nowrap;
}

.head-contain > div >span > .el-button{
  padding: 10px 18px;
}

.el-input {
  padding-left: 5px;
}
.el-date-editor.el-input,.el-date-editor.el-input__inner,.el-input-number,.typeSel {
  width: 100%;
}

.el-table{
  font-size: 12px;
  color: black;
}

.el-link{
  font-size: 12px;
}
.el-table /deep/ .el-table__header .cell .el-checkbox:first-child {
  padding-left: 5px;
}
.footer-contain {
  display: flex;
  padding-top: 6px;
  justify-content: center;
}
.pagination {
  padding-top: 4px;
}
.el-table /deep/ th.el-table__cell {
  background-color: #f9f9f9;
}
.el-table /deep/ thead {
  font-size: 14px;
  color: black;
}
.el-dialog__wrapper /deep/ .el-dialog .el-dialog__body{
  text-align: center;
}
</style>
